import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import MainLayout from "../layout/MainLayout";
import Header from "../components/Header";
import { LuPencilLine } from "react-icons/lu";
import { checkNaN, formatCurrency, generateYearOptions } from "../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import {
  addSalesYear,
  getSalesData,
  getSalesYear,
  updateSalesData,
} from "../redux/reducers/salesSlice";
import Loader from "../components/loader/loader";
import Button from "../components/Button";
import UnPaidCheckout from "./UnPaidCheckout";

const ClinicSales = ({ unPaid }) => {
  const dispatch = useDispatch();
  const { clinicSales, years, loading } = useSelector(
    (state) => state.sales ?? []
  );
  const currentYear = new Date().getFullYear();

  const { userDetails } = useSelector((state) => state.auth);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const { userId } = userDetails;
  // const years = generateYearOptions();

  // Add monthlyData state
  const [monthlyData, setMonthlyData] = useState(
    [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ].map((month) => ({
      month,
      data: [
        {
          type: "Budget",
          servicesRevenue: 0,
          retailRevenue: 0,
          total: 0,
        },
        {
          type: "Actual",
          servicesRevenue: 0,
          retailRevenue: 0,
          total: 0,
        },
      ],
    }))
  );

  // Local state for form data
  const [formData, setFormData] = useState({
    clinicBudget: clinicSales?.clinicBudget || 0,
    retailBudget: clinicSales?.retailBudget || 0,
    dayClinic: {
      clinicServiceDaysThisMonth:
        clinicSales?.dayClinic?.clinicServiceDaysThisMonth || 0,
      clinicServiceHoursPerDay:
        clinicSales?.dayClinic?.clinicServiceHoursPerDay || 0,
      students: clinicSales?.dayClinic?.students || 0,
      availableHours: clinicSales?.dayClinic?.availableHours || 0,
    },
    eveningClinic: {
      clinicServiceDaysThisMonth:
        clinicSales?.eveningClinic?.clinicServiceDaysThisMonth || 0,
      clinicServiceHoursPerDay:
        clinicSales?.eveningClinic?.clinicServiceHoursPerDay || 0,
      students: clinicSales?.eveningClinic?.students || 0,
      availableHours: clinicSales?.eveningClinic?.availableHours || 0,
    },
  });

  const B3 = checkNaN(parseFloat(formData?.clinicBudget).toFixed(2)) || 0;
  const B4 = checkNaN(parseFloat(formData?.retailBudget).toFixed(2)) || 0;
  const B7 =
    checkNaN(parseInt(formData?.dayClinic?.clinicServiceHoursPerDay)) || 0;
  const B8 =
    checkNaN(parseInt(formData?.eveningClinic?.clinicServiceHoursPerDay)) || 0;
  const C7 =
    checkNaN(parseInt(formData?.dayClinic?.clinicServiceDaysThisMonth)) || 0;
  const C8 =
    checkNaN(parseInt(formData?.eveningClinic?.clinicServiceDaysThisMonth)) ||
    0;
  const I7 = checkNaN(parseInt(formData?.dayClinic?.students)) || 0;
  const I8 = checkNaN(parseInt(formData?.eveningClinic?.students)) || 0;

  //Day Clinic
  // const D7 = checkNaN(parseFloat(B7 / (B7 + B8)).toFixed(2));
  const D7 = checkNaN(parseFloat((B7 * C7 * I7) / ((B7 * C7 * I7) + (B8 * C8 * I8))).toFixed(5));
  const E7 = checkNaN(parseFloat(D7 * B3).toFixed(2));
  const F7 = checkNaN(parseFloat(D7 * B4).toFixed(2));
  const G7 = checkNaN(parseFloat(E7 / C7).toFixed(2));
  const H7 = checkNaN(parseFloat(F7 / C7).toFixed(2));
  const J7 = checkNaN(parseFloat(G7 / I7).toFixed(2));
  const K7 = checkNaN(parseFloat(H7 / I7).toFixed(2));
  const L7 = checkNaN(parseFloat(J7 * C7).toFixed(2));
  const M7 = checkNaN(parseFloat(K7 * C7).toFixed(2));

  //Evening Clinic
  // const D8 = checkNaN(parseFloat(B8 / (B7 + B8)).toFixed(2));
  const D8 = checkNaN(parseFloat((B8 * C8 * I8) / ((B7 * C7 * I7) + (B8 * C8 * I8))).toFixed(5));
  const E8 = checkNaN(parseFloat(D8 * B3).toFixed(2));
  const F8 = checkNaN(parseFloat(D8 * B4).toFixed(2));
  const G8 = checkNaN(parseFloat(E8 / C8).toFixed(2));
  const H8 = checkNaN(parseFloat(F8 / C8).toFixed(2));
  const J8 = checkNaN(parseFloat(G8 / I8).toFixed(2));
  const K8 = checkNaN(parseFloat(H8 / I8).toFixed(2));
  const L8 = checkNaN(parseFloat(J8 * C8).toFixed(2));
  const M8 = checkNaN(parseFloat(K8 * C8).toFixed(2));

  const totalDayAvailableClinicHoursMonth = checkNaN(
    parseInt(formData?.dayClinic?.clinicServiceHoursPerDay) *
      parseInt(formData?.dayClinic?.students) *
      parseInt(formData?.dayClinic?.clinicServiceDaysThisMonth)
  );

  const totalEveningAvailableClinicHoursMonth = checkNaN(
    parseInt(formData?.eveningClinic?.clinicServiceHoursPerDay) *
      parseInt(formData?.eveningClinic?.students) *
      parseInt(formData?.eveningClinic?.clinicServiceDaysThisMonth)
  );

  const dayBreakDown = checkNaN(
    parseFloat(
      totalDayAvailableClinicHoursMonth /
        (totalDayAvailableClinicHoursMonth +
          totalEveningAvailableClinicHoursMonth)
    ).toFixed(2)
  );

  const eveningBreakDown = checkNaN(
    parseFloat(
      totalEveningAvailableClinicHoursMonth /
        (totalDayAvailableClinicHoursMonth +
          totalEveningAvailableClinicHoursMonth)
    ).toFixed(2)
  );

  // Fetch initial data
  useEffect(() => {
    if (userId) {
      dispatch(getSalesData(userId));
      dispatch(getSalesYear(userId));
    }
  }, [dispatch, selectedYear, userId]);



  useEffect(() => {
    if (userId) {
     setTimeout(() => {
      dispatch(getSalesData(userId));
      dispatch(getSalesYear(userId));
     }, 1000);
    }
  }, []);

  // Update local state when clinicSales changes
  useEffect(() => {
    if (clinicSales) {
      setFormData({
        clinicBudget: clinicSales.clinicBudget,
        retailBudget: clinicSales.retailBudget,
        dayClinic: clinicSales.dayClinic,
        eveningClinic: clinicSales.eveningClinic,
      });
    }
  }, [clinicSales]);

  // Update monthlyData when clinicSales changes
  useEffect(() => {
    if (clinicSales?.years) {
      const yearData = clinicSales.years.find(
        (y) => y.year === selectedYear ?? currentYear
      );

      if (yearData) {
        setMonthlyData((prevData) =>
          prevData.map((month, idx) => ({
            ...month,
            data: [
              {
                type: "Budget",
                servicesRevenue:
                  yearData.months[idx]?.types?.Budget?.servicesRevenue || 0,
                retailRevenue:
                  yearData.months[idx]?.types?.Budget?.retailRevenue || 0,
                total: 0,
              },
              {
                type: "Actual",
                servicesRevenue:
                  yearData.months[idx]?.types?.Actual?.servicesRevenue || 0,
                retailRevenue:
                  yearData.months[idx]?.types?.Actual?.retailRevenue || 0,
                total: 0,
              },
            ],
          }))
        );
      }
    }
  }, [clinicSales, years, selectedYear]);

  const handleAddYear = (e) => {
    // e.preventDefault();

    dispatch(addSalesYear(userId));
    dispatch(getSalesYear(userId));
    dispatch(getSalesData(userId));
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  // Handler for updating data
  const handleUpdate = async () => {
    const currentYear = new Date().getFullYear();
    const updateData = {
      userId,
      clinicBudget: formData.clinicBudget,
      retailBudget: formData.retailBudget,
      dayClinic: {
        clinicServiceDaysThisMonth:
          formData?.dayClinic.clinicServiceDaysThisMonth || 0,
        clinicServiceHoursPerDay:
          formData?.dayClinic.clinicServiceHoursPerDay || 0,
        students: formData?.dayClinic.students || 0,
        availableHours: formData?.dayClinic.availableHours || 0,
      },
      eveningClinic: {
        clinicServiceDaysThisMonth:
          formData?.eveningClinic.clinicServiceDaysThisMonth || 0,
        clinicServiceHoursPerDay:
          formData?.eveningClinic.clinicServiceHoursPerDay || 0,
        students: formData?.eveningClinic.students || 0,
        availableHours: formData?.eveningClinic.availableHours || 0,
      },
      year: selectedYear,
      yearMonths: monthlyData.map((month) => ({
        name: month.month,
        types: {
          Budget: {
            servicesRevenue: month.data[0].servicesRevenue,
            retailRevenue: month.data[0].retailRevenue,
          },
          Actual: {
            servicesRevenue: month.data[1].servicesRevenue,
            retailRevenue: month.data[1].retailRevenue,
          },
        },
      })),
    };

    await dispatch(updateSalesData(updateData));
    dispatch(getSalesData(userId));
  };

  // Handler for form changes
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Enhanced handler for clinic changes
  const handleClinicChange = (clinic, field, value) => {
    const updatedFormData = {
      ...formData,
      [clinic]: {
        ...formData[clinic],
        [field]: Number(value),
        // Make sure these fields are always included in the payload
        clinicServiceDaysThisMonth:
          formData[clinic].clinicServiceDaysThisMonth || 0,
        clinicServiceHoursPerDay:
          formData[clinic].clinicServiceHoursPerDay || 0,
        students: formData[clinic].students || 0,
        availableHours: formData[clinic].availableHours || 0,
      },
    };

    setFormData(updatedFormData);

    // Automatically update after a delay
    if (window.clinicUpdateTimeout) {
      clearTimeout(window.clinicUpdateTimeout);
    }
    window.clinicUpdateTimeout = setTimeout(() => {
      dispatch(
        updateSalesData({
          userId,
          ...updatedFormData,
          year: new Date().getFullYear(),
          yearMonths: monthlyData.map((month) => ({
            name: month.month,
            types: {
              Budget: {
                servicesRevenue: month.data[0].servicesRevenue,
                retailRevenue: month.data[0].retailRevenue,
              },
              Actual: {
                servicesRevenue: month.data[1].servicesRevenue,
                retailRevenue: month.data[1].retailRevenue,
              },
            },
          })),
        })
      );
    }, 1000);
  };

  // Handler for monthly data changes with automatic update
  const handleMonthlyDataChange = (monthIndex, dataType, field, value) => {
    const updatedMonthlyData = [...monthlyData];
    updatedMonthlyData[monthIndex].data[dataType][field] = Number(value);
    setMonthlyData(updatedMonthlyData);

    // Format data for backend
    const monthUpdates = monthlyData.map((month, idx) => ({
      name: month.month,
      types: {
        Budget: {
          servicesRevenue: month.data[0].servicesRevenue,
          retailRevenue: month.data[0].retailRevenue,
        },
        Actual: {
          servicesRevenue: month.data[1].servicesRevenue,
          retailRevenue: month.data[1].retailRevenue,
        },
      },
    }));

    // Prepare update data
    const updateData = {
      userId,
      ...formData,
      year: selectedYear,
      yearMonths: monthUpdates,
    };

    // // Dispatch update after a short delay to avoid too many requests
    // if (window.updateTimeout) {
    //   clearTimeout(window.updateTimeout);
    // }
    // window.updateTimeout = setTimeout(() => {
    //   dispatch(updateSalesData(updateData));
    // }, 1000);
  };

  // Update dayClinic object in formData
  const handleDayClinicChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      dayClinic: {
        ...prev.dayClinic,
        [field]: value,
      },
    }));
  };

  // Update eveningClinic object in formData
  const handleEveningClinicChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      eveningClinic: {
        ...prev.eveningClinic,
        [field]: value,
      },
    }));
  };

  // Your existing chart data preparation
  const chartData = {
    series: [
      {
        name: "Budgeted Services Revenue",
        data: monthlyData.map((item) =>
          isNaN(parseFloat(item.data[0].servicesRevenue))
            ? 0
            : parseFloat(item.data[0].servicesRevenue)
        ),
      },
      {
        name: "Budgeted Retail Revenue",
        data: monthlyData.map((item) =>
          isNaN(parseFloat(item.data[0].retailRevenue))
            ? 0
            : parseFloat(item.data[0].retailRevenue)
        ),
      },
      {
        name: "Actual Services Revenue",
        data: monthlyData.map((item) =>
          isNaN(parseFloat(item.data[1].servicesRevenue))
            ? 0
            : parseFloat(item.data[1].servicesRevenue)
        ),
      },
      {
        name: "Actual Retail Revenue",
        data: monthlyData.map((item) =>
          isNaN(parseFloat(item.data[1].retailRevenue))
            ? 0
            : parseFloat(item.data[1].retailRevenue)
        ),
      },
    ],
    options: {
      chart: { type: "bar", height: 350 },
      plotOptions: { bar: { horizontal: false, columnWidth: "55%" } },
      dataLabels: { enabled: false },
      xaxis: {
        categories: monthlyData.map((item) => item.month), // Use month names dynamically
      },
      fill: { opacity: 1 },
      stroke: { curve: "smooth" },
      legend: { position: "top" },
    },
  };

  return (
    <MainLayout>
      <Loader loading={loading} />
      {unPaid ? (
        <UnPaidCheckout />
      ) : (
        <>
          <div>
            <Header
              title="Monthly Clinic Calculator"
              description="Manage your Monthly Clinic Calculator and preference here."
              buttonText="Update Records"
              btnOnlcick={handleUpdate}
              className="text-base sm:text-lg md:text-xl"
            />

                  <div className="flex">
                    <div className="flex flex-col w-full border bg-gray-100 border-white text-textColor font-bold mb-10">
                    <div className="flex flex-row w-full justify-center items-center p-4 gap-5 border-2 border-white">
                      <div className="pl-1 font-sans border-white w-1/4 text-xs sm:text-sm md:text-base">
                       <span className=""> Clinic Budget</span>
                      </div>
                      <div className="pl-1 flex flex-row gap-2 items-center justify-start w-full">
                      <input
                        type="number"
                        min={0}
                        value={formData.clinicBudget}
                        onChange={(e) =>
                        handleInputChange(
                          "clinicBudget",
                          Number(e.target.value)
                        )
                        }
                        className="p-3 rounded-xl border-2 border-gray-500 w-1/2 text-xs sm:text-sm md:text-base"
                      />
                      <button className="text-purple-500">
                        <LuPencilLine />
                      </button>
                      </div>
                    </div>

                    <div className="flex flex-row w-full justify-center items-center p-4 gap-5 border-2 border-white">
                      <div className="pl-1 font-sans border-white w-1/4 text-xs sm:text-sm md:text-base">
                      <span>  Retail Budget</span>
                      </div>
                      <div className="pl-1 flex flex-row gap-2 items-center justify-start w-full">
                      <input
                        type="number"
                        min={0}
                        value={formData.retailBudget}
                        onChange={(e) =>
                        handleInputChange(
                          "retailBudget",
                          Number(e.target.value)
                        )
                        }
                        className="p-3 rounded-xl border-2 border-gray-500 w-1/2 text-xs sm:text-sm md:text-base"
                      />
                      <button className="text-purple-500">
                        <LuPencilLine />
                      </button>
                      </div>
                    </div>
                    {/* Similar updates for other inputs */}
              </div>
            </div>

            {/* Clinic Summary Table */}
            {/* <h2 className="text-xl font-semibold mb-4">Clinic Summary</h2> */}
            <div className="overflow-x-auto mb-6">
              <table className="min-w-full bg-white border border-gray-200 text-xs sm:text-sm md:text-base">
                <thead className="">
                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    Name
                  </th>
                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    Clinic Service Hours/Day
                  </th>
                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    # Students
                  </th>
                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    Clinic Hours Available
                  </th>
                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    Clinic Service Days This Month
                  </th>

                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    Total Available Clinic Hours This Month
                  </th>

                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    % Breakdowns
                  </th>

                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    Clinic Sales
                  </th>
                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    Retails Sale
                  </th>
                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    Clinic Sales Per Day
                  </th>
                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    Retail Sales Per Day
                  </th>

                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    Average Daily Clinic Sales Per Std
                  </th>
                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    Average Daily Retail Sales Per Std
                  </th>
                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    Month Clinic Goal
                  </th>
                  <th className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base font-bold text-gray-900 border border-gray-200">
                    Month Retail Goal
                  </th>
                </thead>
                <tbody>
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      Day Clinic
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      <input
                        type="number"
                        min={0}
                        value={formData?.dayClinic?.clinicServiceHoursPerDay}
                        onChange={(e) =>
                          handleDayClinicChange(
                            "clinicServiceHoursPerDay",
                            e.target.value
                          )
                        }
                        placeholder="Clinic Service Hours/Day"
                        className="p-3 rounded-xl border-2 border-gray-500"
                      />
                      <button className="text-purple-500">
                        <LuPencilLine />
                      </button>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      <input
                        type="number"
                        min={0}
                        value={formData?.dayClinic.students}
                        onChange={(e) =>
                          handleDayClinicChange("students", e.target.value)
                        }
                        placeholder="# Students"
                        className="p-3 rounded-xl border-2 border-gray-500"
                      />
                      <button className="text-purple-500">
                        <LuPencilLine />
                      </button>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 text-center border border-gray-200">
                      {checkNaN(
                        parseInt(
                          formData?.dayClinic?.clinicServiceHoursPerDay
                        ) * parseInt(formData?.dayClinic?.students)
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      <input
                        type="number"
                        min={0}
                        name="days"
                        value={formData?.dayClinic?.clinicServiceDaysThisMonth}
                        onChange={(e) =>
                          handleDayClinicChange(
                            "clinicServiceDaysThisMonth",
                            Number(e.target.value)
                          )
                        }
                        placeholder="Day clinic days"
                        className="p-3 rounded-xl border-2 border-gray-500"
                      />
                      <button className="text-purple-500">
                        <LuPencilLine />
                      </button>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {checkNaN(
                        parseInt(
                          formData?.dayClinic?.clinicServiceHoursPerDay
                        ) *
                          parseInt(formData?.dayClinic?.students) *
                          parseInt(
                            formData?.dayClinic?.clinicServiceDaysThisMonth
                          )
                      )}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {parseFloat(dayBreakDown * 100 ?? 0).toFixed(2)}%
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(E7 ?? 0)}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(F7 ?? 0)}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(G7 ?? 0)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(H7 ?? 0)}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(J7 ?? 0)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(K7 ?? 0)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(L7 ?? 0)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(M7 ?? 0)}
                    </td>
                  </tr>

                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      Evening Clinic
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      <input
                        type="number"
                        min={0}
                        value={
                          formData?.eveningClinic.clinicServiceHoursPerDay || 0
                        }
                        onChange={(e) =>
                          handleEveningClinicChange(
                            "clinicServiceHoursPerDay",
                            e.target.value
                          )
                        }
                        className="p-3 rounded-xl border-2 border-gray-500"
                      />
                      <button className="text-purple-500">
                        <LuPencilLine />
                      </button>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      <input
                        type="number"
                        min={0}
                        value={formData?.eveningClinic.students || 0}
                        onChange={(e) =>
                          handleEveningClinicChange("students", e.target.value)
                        }
                        className="p-3 rounded-xl border-2 border-gray-500"
                      />
                      <button className="text-purple-500">
                        <LuPencilLine />
                      </button>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 text-center border border-gray-200">
                      {checkNaN(
                        parseInt(
                          formData?.eveningClinic?.clinicServiceHoursPerDay
                        ) * parseInt(formData?.eveningClinic?.students)
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      <input
                        type="number"
                        min={0}
                        value={
                          formData?.eveningClinic.clinicServiceDaysThisMonth ||
                          0
                        }
                        onChange={(e) =>
                          handleEveningClinicChange(
                            "clinicServiceDaysThisMonth",
                            e.target.value
                          )
                        }
                        className="p-3 rounded-xl border-2 border-gray-500"
                      />
                      <button className="text-purple-500">
                        <LuPencilLine />
                      </button>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {isNaN(
                        parseInt(
                          formData?.eveningClinic?.clinicServiceHoursPerDay
                        ) *
                          parseInt(formData?.eveningClinic?.students) *
                          parseInt(
                            formData?.eveningClinic?.clinicServiceDaysThisMonth
                          )
                      )
                        ? 0
                        : parseInt(
                            formData?.eveningClinic?.clinicServiceHoursPerDay
                          ) *
                          parseInt(formData?.eveningClinic?.students) *
                          parseInt(
                            formData?.eveningClinic?.clinicServiceDaysThisMonth
                          )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {parseFloat(eveningBreakDown * 100 ?? 0).toFixed(2)}%
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(E8 ?? 0)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(F8 ?? 0)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(G8 ?? 0)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(H8 ?? 0)}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(J8 ?? 0)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(K8 ?? 0)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(L8 ?? 0)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(M8 ?? 0)}
                    </td>
                  </tr>

                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      TTL Clinic
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {checkNaN(
                        checkNaN(
                          parseInt(
                            formData?.dayClinic?.clinicServiceHoursPerDay
                          )
                        ) +
                          checkNaN(
                            parseInt(
                              formData?.eveningClinic?.clinicServiceHoursPerDay
                            )
                          )
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {checkNaN(
                        parseInt(formData?.dayClinic?.students) +
                          parseInt(formData?.eveningClinic?.students)
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border text-center border-gray-200">
                      {checkNaN(
                        parseInt(
                          formData?.dayClinic?.clinicServiceHoursPerDay
                        ) *
                          parseInt(formData?.dayClinic?.students) +
                          parseInt(
                            formData?.eveningClinic?.clinicServiceHoursPerDay
                          ) *
                            parseInt(formData?.eveningClinic?.students)
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {checkNaN(
                        parseInt(
                          formData?.dayClinic?.clinicServiceDaysThisMonth
                        ) +
                          parseInt(
                            formData?.eveningClinic?.clinicServiceDaysThisMonth
                          )
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {checkNaN(
                        parseInt(
                          formData?.dayClinic?.clinicServiceHoursPerDay
                        ) *
                          parseInt(formData?.dayClinic?.students) *
                          parseInt(
                            formData?.dayClinic?.clinicServiceDaysThisMonth
                          ) +
                          parseInt(
                            formData?.eveningClinic?.clinicServiceHoursPerDay
                          ) *
                            parseInt(formData?.eveningClinic?.students) *
                            parseInt(
                              formData?.eveningClinic
                                ?.clinicServiceDaysThisMonth
                            )
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {checkNaN((parseFloat(D7) + parseFloat(D8)) * 100)} %
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(
                        checkNaN(parseFloat(E7) + parseFloat(E8))
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(
                        checkNaN(parseFloat(F7) + parseFloat(F8))
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(
                        checkNaN(parseFloat(G7) + parseFloat(G8))
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(
                        checkNaN(parseFloat(H7) + parseFloat(H8))
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(
                        checkNaN(parseFloat(J7) + parseFloat(J8))
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(
                        checkNaN(parseFloat(K7) + parseFloat(K8))
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(
                        checkNaN(parseFloat(L7) + parseFloat(L8))
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-xs sm:text-sm md:text-base text-gray-900 border border-gray-200">
                      {formatCurrency(
                        checkNaN(parseFloat(M7) + parseFloat(M8))
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Header
              title="Clinic Sales"
              // description="Manage your Monthly Clinic Calculator and preference here."
              buttonText=" Add New Year"
              btnOnlcick={handleAddYear}
            >
              <select
                className="bg-purple-600 hover:bg-purple-700 px-5 py-3 text-white rounded-xl"
                value={selectedYear}
                onChange={(e) => setSelectedYear(Number(e.target.value))}
              >
                <option value={currentYear}>{currentYear}</option>
                {years?.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </Header>
            <div className="overflow-x-auto my-10">
              <table className="min-w-full bg-white border border-gray-200">
                <thead>
                  <tr>
                    <th className="px-6 py-4 text-sm font-bold text-gray-900 border border-gray-200">
                      Month
                    </th>
                    <th className="px-6 py-4 text-sm font-bold text-gray-900 border border-gray-200">
                      Type
                    </th>
                    <th className="px-6 py-4 text-sm font-bold text-gray-900 border border-gray-200">
                      Services Revenue
                    </th>
                    <th className="px-6 py-4 text-sm font-bold text-gray-900 border border-gray-200">
                      Retail Revenue
                    </th>
                    <th className="px-6 py-4 text-sm font-bold text-gray-900 border border-gray-200">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {monthlyData.map((row, idx) => (
                    <>
                      {/* First row for Budget */}
                      <tr key={`${idx}-budget`}>
                        <td
                          className="px-6 py-4 text-sm text-gray-900 border border-gray-200"
                          rowSpan={2}
                        >
                          {row.month}
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 border border-gray-200">
                          Budget
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 border border-gray-200">
                          <input
                            type="number"
                            className="p-3 rounded-xl border-2 border-gray-500 w-11/12"
                            min={0}
                            value={row.data[0].servicesRevenue}
                            onChange={(e) =>
                              handleMonthlyDataChange(
                                idx,
                                0,
                                "servicesRevenue",
                                e.target.value
                              )
                            }
                          />
                          <button className="text-purple-500">
                            <LuPencilLine />
                          </button>
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 border border-gray-200">
                          <input
                            type="number"
                            className="p-3 rounded-xl border-2 border-gray-500 w-11/12"
                            value={row.data[0].retailRevenue}
                            min={0}
                            onChange={(e) =>
                              handleMonthlyDataChange(
                                idx,
                                0,
                                "retailRevenue",
                                e.target.value
                              )
                            }
                          />
                          <button className="text-purple-500">
                            <LuPencilLine />
                          </button>
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 border border-gray-200">
                          {
                            parseFloat(parseFloat(row.data[0].servicesRevenue || 0) +
                            parseFloat(row.data[0].retailRevenue || 0)).toFixed(2)
                          }
                        </td>
                      </tr>

                      {/* Second row for Actual */}
                      <tr key={`${idx}-actual`}>
                        <td className="px-6 py-4 text-sm text-gray-900 border border-gray-200">
                          Actual
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 border border-gray-200">
                          <input
                            type="number"
                            className="p-3 rounded-xl border-2 border-gray-500 w-11/12"
                            value={row.data[1].servicesRevenue}
                            min={0}
                            onChange={(e) =>
                              handleMonthlyDataChange(
                                idx,
                                1,
                                "servicesRevenue",
                                e.target.value
                              )
                            }
                          />
                          <button className="text-purple-500">
                            <LuPencilLine />
                          </button>
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 border border-gray-200">
                          <input
                            type="number"
                            className="p-3 rounded-xl border-2 border-gray-500 w-11/12"
                            value={row.data[1].retailRevenue}
                            min={0}
                            onChange={(e) =>
                              handleMonthlyDataChange(
                                idx,
                                1,
                                "retailRevenue",
                                e.target.value
                              )
                            }
                          />
                          <button className="text-purple-500">
                            <LuPencilLine />
                          </button>
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 border border-gray-200">
                          {
                            parseFloat(parseFloat(row.data[1].servicesRevenue || 0) +
                            parseFloat(row.data[1].retailRevenue || 0)).toFixed(2)
                          }
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>

            {/* ApexCharts */}
            <div className="my-10">
              <Header title={"  Clinic Sales - Budgeted Vs Actual"} />
            </div>
            <div className="w-full">
              <Chart
                options={chartData.options}
                series={chartData.series}
                type="bar"
                height={350}
              />
            </div>
          </div>
        </>
      )}
    </MainLayout>
  );
};

export default ClinicSales;
